import { Box, Grid, GridItem, Heading, Progress, Skeleton, Text, VStack } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { dollarPrice, numberWithCommas } from '../../utility/Utils'
import { DashboardCard } from './Dashboard.DashboardCard'

/**
 *
 * @returns JSX.Element
 */
export default function DashboardAgency() {
  /** @type {import('../../reducers/dashboardReducer').DashboardState} */
  const { total_unique_users, total_orders, portals_online, net_sales, active_users, new_users } = useSelector(
    state => state.dashboard
  )

  return (
    <Grid templateColumns={{ base: 'repeat(3, 1fr)', md: 'repeat(6, 1fr)', lg: 'repeat(12, 1fr)' }} gap={8} rowGap={16}>
      <GridItem colSpan={3}>
        <DashboardCard>
          <Skeleton isLoaded={typeof total_unique_users === 'number'}>
            <Text>{numberWithCommas(total_unique_users)}</Text>
          </Skeleton>
          <Heading as="h6" size="xs">
            Total Users
          </Heading>
        </DashboardCard>
      </GridItem>
      <GridItem colSpan={3}>
        <DashboardCard>
          <Skeleton isLoaded={typeof total_orders === 'number'}>
            <Text>{numberWithCommas(total_orders)}</Text>
          </Skeleton>
          <Heading as="h6" size="xs">
            Total Orders
          </Heading>
        </DashboardCard>
      </GridItem>
      <GridItem colSpan={3}>
        <DashboardCard>
          <Skeleton isLoaded={typeof portals_online === 'number'}>
            <Text>{numberWithCommas(portals_online)}</Text>
          </Skeleton>
          <Heading as="h6" size="xs">
            Total Portals
          </Heading>
        </DashboardCard>
      </GridItem>
      <GridItem colSpan={3}>
        <DashboardCard>
          <Skeleton isLoaded={typeof net_sales === 'number'}>
            <Text>${dollarPrice(net_sales)}</Text>
          </Skeleton>
          <Heading as="h6" size="xs">
            Month Net Sales
          </Heading>
        </DashboardCard>
      </GridItem>
      <GridItem colSpan={{ base: 3, md: 6, lg: 12 }}>
        <DashboardCard position="relative" overflow="hidden">
          <Box as="header" position="absolute" top={0} left={0} bg="primary.400" w="full" p={4}>
            <Heading as="h5" size="sm" color="white">
              Past Month:
            </Heading>
          </Box>
          <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }} gap={8} mt={20}>
            <GridItem as={VStack} colSpan={1} spacing={4}>
              <VStack as="header">
                <Heading as="h6" size="sm" color="neutral.500" mb={0}>
                  Active Users
                </Heading>
                <Text color="fg">
                  {active_users} Users ({((active_users / total_unique_users) * 100).toFixed(2)}%)
                </Text>
              </VStack>
              <Progress value={active_users / total_unique_users} minW="full" />
            </GridItem>
            <GridItem as={VStack} colSpan={1} spacing={4}>
              <VStack as="header">
                <Heading as="h6" size="sm" color="neutral.500" mb={0}>
                  New Users
                </Heading>
                <Text color="fg">
                  {new_users} Users ({((new_users / total_unique_users) * 100).toFixed(2)}%)
                </Text>
              </VStack>
              <Progress value={new_users / total_unique_users} minW="full" />
            </GridItem>
          </Grid>
        </DashboardCard>
      </GridItem>
    </Grid>
  )
}
